const froalaConfig = {
  // Include all the extension you want in froala editor
  toolbarButtons: [
    'fullscreen',
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    '|',
    'fontSize',
    'color',
    'paragraphStyle',
    'paragraphFormat',
    '|',
    'blockquote',
    'align',
    'formatOL',
    'formatUL',
    '|',
    'gallery',
    'insertLink',
    'insertVideo',
    'insertTable',
    '|',
    'specialCharacters',
    'insertHR',
    'selectAll',
    'clearFormatting',
    '|',
    'help',
    'html',
    '|',
    'undo',
    'redo',
  ],

  paragraphStyles: {
    'text-style-hed-l': 'Stor tittel',
    'text-style-hed': 'Normal tittel',
    'text-style-hed-m': 'Medium tittel',
    'text-style-hed-s': 'Liten tittel',
    'text-style-body': 'Brødtekst',
    'text-style-s': 'Liten tekst',
    'text-uppercase': 'Uppercase',
    'text-transform-none': 'Ingen uppercase',
  },

  linkStyles: {
    'btn btn-primary': 'Hovedknapp',
    'btn btn-primary btn--arrow btn--arrow-light': 'Hovedknapp med pil',
  },

  imageStyles: {
    'img-fluid': 'Responsivt bilde',
  },

  imageEditButtons: [
    'imageAlign',
    'imageRemove',
    '|',
    'imageLink',
    'linkOpen',
    'linkEdit',
    'linkRemove',
    '-',
    'imageDisplay',
    'imageStyle',
    'imageAlt',
  ],

  videoEditButtons: [
    'videoReplace',
    'videoRemove',
    '|',
    'videoDisplay',
    'videoAlign',
  ],

  videoInsertButtons: [
    'videoBack',
    '|',
    'videoByURL',
    'videoEmbed',
  ],

  quickInsertButtons: [
    'table',
    'ul',
    'ol',
    'hr',
  ],
};

window.froalaConfig = froalaConfig;

export default froalaConfig;
